module.exports = __webpack_public_path__ + "static/parade-2020-house03-e9ae362c08a5b75a9467d8f49bc4c0b7.jpg";